import { Container, Title, Table, Badge, Button, Group, Loader, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { bidCommitteeApi } from "../../../api/bidCommittee";

export function AgendaReturnFormList() {
  const navigate = useNavigate();
  const { data: forms, isLoading } = useQuery({
    queryKey: ["agendaReturnForms"],
    queryFn: async () => {
      const res = await bidCommitteeApi.listAgendaReturnForms();
      return res.data;
    },
  });

  if (isLoading) {
    return (
      <Container py="xl">
        <Loader />
      </Container>
    );
  }

  return (
    <Container size="lg" py="xl">
      <Group justify="space-between" mb="lg">
        <Title order={2}>Agenda return forms</Title>
        <Button onClick={() => navigate("/bid-committee/meetings")}>From a meeting</Button>
      </Group>

      {!forms?.length ? (
        <Text c="dimmed">No agenda return forms yet.</Text>
      ) : (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Form</Table.Th>
              <Table.Th>Meeting</Table.Th>
              <Table.Th>Agenda item</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {forms.map((f) => (
              <Table.Tr key={f.id}>
                <Table.Td>{f.formNumber ?? f.id.slice(0, 8)}</Table.Td>
                <Table.Td>{f.meeting?.meetingNumber ?? "—"}</Table.Td>
                <Table.Td>{f.agendaItem?.subject ?? "—"}</Table.Td>
                <Table.Td>
                  <Badge>{f.status}</Badge>
                </Table.Td>
                <Table.Td>
                  <Button
                    variant="subtle"
                    size="xs"
                    onClick={() => navigate(`/bid-committee/agenda-return-forms/${f.id}`)}
                  >
                    View
                  </Button>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Container>
  );
}
